export default {"src":"/_next/static/media/icon-search.403456b3.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};